
<nav class="navbar navbar-expand-lg navbar-dark bg-dark">
  <a class="navbar-brand brand" href="#">Heart Disease Predictor</a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <mat-icon>more_vert</mat-icon>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav ml-5">
      <li class="nav-item ml-2">
        <a class="nav-link" routerLink="/home">Home <span class="sr-only">(current)</span></a>
      </li>
      <li class="nav-item ml-2">
        <a class="nav-link" routerLink="/about">About Dataset</a>
      </li>

      <li class="nav-item ml-2" *ngIf="isLogin()==false">
        <a class="nav-link" routerLink="/login">Login</a>
      </li>

      <li class="nav-item ml-2" *ngIf="isLogin()==true">
        <a class="nav-link" routerLink="/user">{{account.username}}</a>
      </li>


      <li class="nav-item ml-2" *ngIf="isLogin()==true">
        <button type="button" class="btn btn-primary" (click)="logout()">Logout</button>
      </li>

    </ul>

  </div>
</nav>
<router-outlet></router-outlet>



<footer class="foot">
<h2 class="m-2">All copyrights&copy; are reserved for this application</h2>
<h4><em>Developed and Maintained by <b>Ishank Chopra</b></em></h4>

</footer>
